<template>
  <div>
    <div v-if="anyUserOrganizationsAvailable">
      <v-row
        align="center"
        class="mb-3 mt-4"
      >
        <v-col
          cols="7"
          class="pr-0"
        >
          <v-btn
            icon
            @click="prevMonth"
          >
            <v-icon color="#000">
              mdi-chevron-left
            </v-icon>
          </v-btn>
          <span
            class=""
          >{{ monthNames[selectedMonth] }} {{ selectedYear }}</span>
          <v-btn
            icon
            @click="nextMonth"
          >
            <v-icon color="#000">
              mdi-chevron-right
            </v-icon>
          </v-btn>
        </v-col>
        <v-col
          cols="5"
          class="text-right pl-0"
        >
          <v-btn
            color="#FFFFFF"
            outlined
            class="next-style"
            elevation="0"
            @click="showFilterDialog = true"
          >
            Filter
          </v-btn>&nbsp;&nbsp;
          <v-btn
            dark
            fab
            outlined
            icon
            color="#37474F"
            small
            @click="clearFilter()"
          >
            <v-icon
              small
              dark
            >
              mdi-filter-off
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row
        ref="dateScrollContainer"
        class="flex-nowrap ma-2 mb-0"
        style="
          overflow-x: auto;
          white-space: nowrap;
          -ms-overflow-style: none;
          scrollbar-width: none;
        "
      >
        <v-card
          v-for="(day, index) in daysInMonth"
          :key="index"
          :ref="isToday(day) ? 'todayCard' : null"
          class="ma-2 py-1 text-center"
          :class="isSelected(day) ? 'selected-day-card' : 'default-day-card'"
          style="min-width: 60px; max-width: 60px; margin: 5px !important"
          elevation="0"
          color="#FFF"
          @click="selectDate(day)"
        >
          <div class="text-caption">
            {{ dayNames[new Date(day).getDay()] }}
          </div>
          <div class="text-subtitle-1">
            {{ new Date(day).getDate() }}
          </div>
        </v-card>
      </v-row>
      <v-row justify="center">
        <v-col
          cols="12"
          class="pt-0"
        >
          <div v-if="jobsListAvailable">
            <v-card
              v-for="(item, index) in jobsList"
              :key="index"
              color="#FFF"
              dark
              class="card-style pa-3"
              elevation="0"
              @click.stop
              @click="jobDetails(item.external_id)"
            >
              <template v-if="confirmingJobId === item.external_id">
                <v-card-text class="text-center">
                  <p class="mb-4">
                    Are you sure you want to update the progress of
                    {{ projectName }} to {{ tempProgress }}% ?
                  </p>
                  <v-btn
                    small
                    color="green"
                    @click.stop="confirmUpdate(item)"
                  >
                    Yes
                  </v-btn>
                  <v-btn
                    small
                    color="red"
                    outlined
                    class="ml-2"
                    @click.stop="cancelUpdate(item)"
                  >
                    No
                  </v-btn>
                </v-card-text>
              </template>
              <template v-else>
                <v-card-text>
                  <div class="content-wrapper">
                    <h3 color="#000">
                      {{ item.name }}
                    </h3>
                    <v-chip
                      dark
                      color="transparent"
                      small
                      elevation="0"
                      label
                      class="text-format"
                    >
                      <v-icon
                        x-small
                        :color="cardColor(item.priority)"
                        class="pr-1"
                      >
                        mdi-circle
                      </v-icon>
                      {{ item.priority }}
                    </v-chip>
                  </div>
                  <div class="content-wrapper">
                    <p class="title-text-style">
                      <font v-if="item.project !== null">
                        {{ item.project.name }}
                      </font>
                      <font v-else>
                        N/A
                      </font>
                    </p>
                  </div>
                  <div class="content-wrapper">
                    <span class="title-text-style">
                      <v-icon
                        color="#37474F"
                        size="20"
                      >
                        mdi-account-check
                      </v-icon>
                      <font v-if="item.assigned_to_name !== null">
                        {{ item.assigned_to_name }}
                      </font>
                      <font v-else> N/A</font>
                    </span>
                  </div>
                  <div class="d-flex justify-content-center align-center">
                    <v-slider
                      v-model="item.progress"
                      :max="100"
                      :min="0"
                      step="1"
                      color="blue-grey"
                      thumb-size="12"
                      hide-details
                      dense
                      class="flex-grow-1"
                      @change="confirmUpdate(item)"
                    />

                    <b
                      class="black--text ml-2"
                    >{{ Math.ceil(item.progress) }}%</b>
                  </div>

                  <div class="time-style">
                    <p>
                      <v-icon
                        color="green"
                        size="18"
                      >
                        mdi-calendar-start
                      </v-icon>
                      <font
                        v-if="item.actual_start_date !== null"
                        class="value-text-style"
                        style="text-transform: uppercase"
                      >
                        {{ item.actual_start_date | convertToLocal }}
                      </font>
                      <font
                        v-else
                        class="value-text-style"
                        style="text-transform: uppercase"
                      >
                        {{ item.planned_start_date | convertToLocal }}
                      </font>
                    </p>
                    <p>
                      <v-icon
                        color="red"
                        size="18"
                      >
                        mdi-calendar-end
                      </v-icon>
                      <font
                        v-if="item.actual_end_date !== null"
                        class="value-text-style"
                        style="text-transform: uppercase"
                      >
                        {{ item.actual_end_date | convertToLocal }}
                      </font>
                      <font
                        v-else
                        class="value-text-style"
                        style="text-transform: uppercase"
                      >
                        {{ item.planned_end_date | convertToLocal }}
                      </font>
                    </p>
                  </div>
                  <div class="content-wrapper align-center">
                    <div>
                      <v-menu
                        ref="statusMenu"
                        offset-y
                        :close-on-content-click="true"
                        :nudge-width="0"
                        content-class="status-menu"
                        attach
                      >
                        <template #activator="{ on, attrs }">
                          <div
                            class="status-activator"
                            v-bind="attrs"
                            v-on="on"
                            @click.stop
                          >
                            <v-chip
                              small
                              :color="statusColor(getStatusObject(item).id)"
                              dark
                              label
                              class="ma-0"
                            >
                              <font color="#fff">
                                {{ getStatusObject(item).title }}
                                <v-icon
                                  small
                                  class="status-chevron"
                                >
                                  mdi-menu-down
                                </v-icon>
                              </font>
                            </v-chip>
                          </div>
                        </template>
                        <v-list
                          class="ma-0 pa-0"
                          dense
                        >
                          <v-list-item
                            v-for="s in statusList"
                            :key="s.id"
                            class="mt-0 mb-0"
                            @click.stop="changeStatus(item, s, index)"
                          >
                            <v-list-item-content class="pt-0 pb-0">
                              <v-chip
                                small
                                :color="statusColor(s.id)"
                                light
                                label
                                class="ma-0"
                              >
                                <font color="#fff">
                                  {{ s.title }}
                                </font>
                              </v-chip>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                    <div class="button-group">
                      <v-btn
                        small
                        elevation="0"
                        style=""
                        light
                        @click.stop
                        @click="jobComments(item.external_id)"
                      >
                        <v-icon small>
                          mdi-plus
                        </v-icon>
                        <span
                          style="text-transform: capitalize"
                        >add notes</span>
                      </v-btn>
                    </div>
                  </div>
                </v-card-text>
              </template>
            </v-card>
            <br>
            <br>
            <div class="text-center">
              <v-btn
                v-if="jobsList.length < totalJobs"
                class="load-more-btn"
                small
                outlined
                color="#000"
                elevation="0"
                @click="loadMore()"
              >
                Load More
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </div>
            <br>
          </div>
          <div
            v-else
            class="empty-alert-div mt-5"
          >
            <v-card
              color="#FFF"
              elevation="0"
            >
              <br>
              <br>
              <br>
              <p class="empty-alert-msg">
                <v-icon
                  size="25"
                  color="#C62828"
                >
                  mdi-information-outline
                </v-icon>No schedule found
              </p>
              <br>
              <br>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </div>
    <div
      v-else
      class="empty-alert-div pt-4"
    >
      <v-card
        color="#FFF"
        elevation="0"
      >
        <br>
        <br>
        <br>
        <p class="empty-alert-msg">
          <v-icon
            size="25"
            color="#C62828"
          >
            mdi-information-outline
          </v-icon>No
          Organizations found
        </p>
        <br>
        <br>
      </v-card>
    </div>
    <centre-spinner :loading="loading" />
    <filter-jobs-dialog
      v-if="showFilterDialog"
      @closed="showFilterDialog = false"
      @filterData="filterAcceptedJobs"
    />
  </div>
</template>

<script>
import spinner from 'src/views/components/SpinnerCentre';
import FilterJobsDialog from './FilterJobsDialog.vue';
import moment from 'moment';

export default {
  name: 'JobsAccepted',
  components: {
    'filter-jobs-dialog': FilterJobsDialog,
    'centre-spinner': spinner,
  },
  filters: {
    convertToLocal (stringDatetime) {
      return moment.utc(stringDatetime).local().format('D, ddd hh:mm A');
    },
  },
  data: () => ({
    loading: false,
    jobLoading: false,
    confirmingJobId: null,
    tempProgress: null,
    showFilterDialog: false,
    filteredData: null,
    startPage: 0,
    statusId: '',
    projectName: null,
    statusList: [
      {
        title: 'ACTIVE',
        id: 'active',
      },
      {
        title: 'PENDING',
        id: 'pending',
      },
      {
        title: 'COMPLETED',
        id: 'completed',
      },
    ],
    selectedDate: new Date().toISOString().substr(0, 10),
    selectedMonth: new Date().getMonth(),
    selectedYear: new Date().getFullYear(),
    dayNames: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    monthNames: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
  }),
  computed: {
    appUserOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
    daysInMonth () {
      const days = [];
      const year = this.selectedYear;
      const month = this.selectedMonth;
      const date = new Date(year, month, 1);

      while (date.getMonth() === month) {
        days.push(new Date(date).toLocaleDateString('en-CA'));
        date.setDate(date.getDate() + 1);
      }
      return days;
    },
    anyUserOrganizationsAvailable () {
      if (this.appUserOrganizationsList.length !== 0) {
        return true;
      }
      return false;
    },
    appUserOrganizationsList () {
      return this.$store.getters['organization/getUserOrganizations'];
    },
    jobsList () {
      return this.$store.getters['jobs/getAcceptedJobs'];
    },
    jobsListAvailable () {
      if (this.jobsList.length === 0) {
        return false;
      }
      return true;
    },
    totalJobs () {
      return this.$store.getters['jobs/getTotalAcceptedJobs'];
    },
    jobFilters () {
      return this.$store.getters['jobs/getJobFilters'];
    },
  },
  async mounted () {
    this.loading = true;
    this.$store.dispatch('jobs/clearAppUserAcceptedJobs');
    await this.getUserOrganizations();
    this.anyUserOrganizationsAvailable && (await this.checkStoreFilter());
    this.anyUserOrganizationsAvailable && (await this.getAcceptedJobs());
    this.scrollToToday();
    this.loading = false;
  },
  methods: {
    async checkStoreFilter () {
      if (Object.keys(this.jobFilters).length !== 0) {
        this.filteredData = this.jobFilters;
      } else {
        this.filteredData = null;
      }
    },
    askConfirm (item) {
      this.confirmingJobId = item.external_id;
      this.tempProgress = item.progress;
      this.projectName = item.name;
    },

    async confirmUpdate (item) {
      this.loading = true;
      await this.$store.dispatch('jobs/saveProgress', {
        formData: {
          progress: String(item.progress),
          status: item.status,
        },
        jobId: item.external_id,
      });
      this.loading = false;

      // reset confirmation state
      this.confirmingJobId = null;
      this.tempProgress = null;
      this.projectName = null;
    },
    // async updateStatus (item) {
    //   this.loading = true;
    //   await this.$store.dispatch('jobs/saveProgress', {
    //     formData: {
    //       progress: String(item.progress),
    //       status: item.status,
    //     },
    //     jobId: item.external_id,
    //   });
    //   this.loading = false;

    //   // reset confirmation state
    //   this.confirmingJobId = null;
    //   this.tempProgress = null;
    //   this.projectName = null;
    // },

    cancelUpdate (item) {
      this.clearFilter();
      this.confirmingJobId = null;
      this.tempProgress = null;
    },
    isSelected (date) {
      return new Date(date).getTime() === new Date(this.selectedDate).getTime();
    },
    selectDate (date) {
      this.$store.dispatch('jobs/clearAppUserAcceptedJobs');
      this.startPage = 0;
      this.selectedDate = date;
      this.getAcceptedJobs();
    },
    prevMonth () {
      if (this.selectedMonth === 0) {
        this.selectedMonth = 11;
        this.selectedYear -= 1;
      } else {
        this.selectedMonth--;
      }
    },
    nextMonth () {
      if (this.selectedMonth === 11) {
        this.selectedMonth = 0;
        this.selectedYear += 1;
      } else {
        this.selectedMonth++;
      }
    },
    cardStyle (date) {
      if (this.isSelected(date)) {
        return {
          backgroundColor: 'black',
          color: 'white',
          border: '1px solid black',
          minWidth: '60px',
          cursor: 'pointer',
        };
      } else {
        return {
          backgroundColor: 'transparent',
          color: 'black',
          border: '1px solid black',
          minWidth: '60px',
          cursor: 'pointer',
        };
      }
    },
    async loadMore () {
      if (
        event.currentTarget.classList.contains(
          'v-expansion-panel-header--active',
        )
      ) {
        return;
      }
      this.startPage += 5;
      await this.getAcceptedJobs(this.statusId);
    },
    async getAcceptedJobs (status) {
      await this.$store.dispatch('jobs/fetchAcceptedJobs', {
        externalId: this.appUserOrganization.organization.external_id,
        params: {
          params: {
            priority:
              this.filteredData !== null
                ? this.filteredData.priority !== ''
                  ? this.filteredData.priority
                  : null
                : null,
            jobStatus:
              this.filteredData !== null
                ? this.filteredData.status !== ''
                  ? this.filteredData.status
                  : null
                : null,
            plannedEndTo:
              this.selectedDate !== null
                ? moment(this.selectedDate + ' 00:00:00', 'YYYY-MM-DD hh:mm:ss')
                    .utc()
                    .format()
                : null,
            plannedStartFrom:
              this.selectedDate !== null
                ? moment(this.selectedDate + ' 23:59:59', 'YYYY-MM-DD hh:mm:ss')
                    .utc()
                    .format()
                : null,
            from:
              this.filteredData !== null
                ? this.filteredData.startDate !== ''
                  ? this.filteredData.startDate
                  : null
                : null,
            to:
              this.filteredData !== null
                ? this.filteredData.endDate !== ''
                  ? this.filteredData.endDate
                  : null
                : null,
            month:
              this.filteredData !== null
                ? this.filteredData.month !== ''
                  ? `${this.filteredData.month}-10`
                  : null
                : null,
            jobType:
              this.filteredData !== null
                ? this.filteredData.type !== ''
                  ? this.filteredData.type
                  : null
                : null,
            project:
              this.filteredData !== null
                ? this.filteredData.project !== ''
                  ? this.filteredData.project
                  : null
                : null,
            startPage: this.startPage,
            limit: 5,
            status: 'accepted',
          },
        },
      });
    },
    async getUserOrganizations () {
      await this.$store.dispatch('organization/fetchUserOrganizations', {
        params: {
          requestStatus: 'accepted',
        },
      });
    },

    getStatusObject (item) {
      if (!item) return { id: '', title: '' };
      if (item.status && typeof item.status === 'object') return item.status;
      const found = this.statusList.find((s) => s.id === item.status);
      return (
        found || {
          id: item.status || '',
          title: String(item.status || '').toUpperCase(),
        }
      );
    },

    async changeStatus (item, statusObj, index) {
      this.$set(item, 'status', statusObj.id);
      await this.updateStatus(item, statusObj.id);

      // Close the correct menu by index
      if (this.$refs.statusMenu && this.$refs.statusMenu[index]) {
        this.$refs.statusMenu[index].isActive = false;
      }
    },

    async updateStatus (item, statusValue) {
      this.loading = true;
      try {
        await this.$store.dispatch('jobs/saveProgress', {
          formData: {
            progress: String(item.progress),
            status: statusValue,
          },
          jobId: item.external_id,
        });
      } finally {
        this.loading = false;
      }
    },

    async clearFilter () {
      this.loading = true;
      this.startPage = 0;
      this.filteredData = null;
      await this.$store.dispatch('jobs/clearAppUserAcceptedJobs');
      this.$store.dispatch('jobs/storeJobFilters', {});
      await this.getAcceptedJobs(this.statusId);
      this.loading = false;
    },
    async filterAcceptedJobs (data) {
      this.loading = true;
      this.startPage = 0;
      this.filteredData = data;
      await this.$store.dispatch('jobs/clearAppUserAcceptedJobs');
      await this.getAcceptedJobs(this.statusId);
      this.loading = false;
    },
    jobDetails (id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ path: `/jobs/${id}/details` });
      }, 1000);
    },
    jobComments (id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ path: `/jobs/${id}/comments` });
        this.loading = false;
      }, 1000);
    },
    isToday (day) {
      const today = new Date();
      const date = new Date(day);
      return (
        date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear()
      );
    },
    scrollToToday () {
      this.$nextTick(() => {
        setTimeout(() => {
          let el = this.$refs.todayCard;
          if (Array.isArray(el)) el = el[0];
          if (el && el.$el) {
            el = el.$el;
          }
          if (el) {
            const container = this.$refs.dateScrollContainer;
            const containerWidth = container.offsetWidth;
            const scrollLeft =
              el.offsetLeft - containerWidth / 2 + el.offsetWidth / 2;
            container.scrollTo({ left: scrollLeft, behavior: 'smooth' });
          }
        }, 50);
      });
    },
    statusColor (val) {
      if (val === 'active') return 'green';
      if (val === 'pending') return 'orange';
      if (val === 'completed') return 'blue';
      return 'grey';
    },
    cardColor (val) {
      if (val === 'low') {
        return 'green';
      } else if (val === 'medium') {
        return 'yellow';
      } else if (val === 'high') {
        return 'orange';
      } else {
        return 'red';
      }
    },
  },
};
</script>
<style scoped>
.card-style {
  border-radius: 10px;
  margin-bottom: 10px;
}

.observer {
  height: 40px;
}

.time-style .value-text-style {
  font-size: 12px;
}

.time-style {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 6px;
}

.empty-alert-msg {
  padding: 12px;
}

.next-style,
.cancel-style {
  font-size: 12px;
  width: 80px;
  font-weight: lighter !important;
  text-transform: none !important;
}

.content-wrapper {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.text-format {
  text-transform: capitalize;
}

.status-style {
  display: flex;
  justify-content: flex-end;
  width: fit-content;
  float: right;
  text-transform: capitalize;
}

.assigner_style {
  font-size: 13px;
  border: 1px #ccc;
}

.subheader-style {
  text-transform: capitalize;
}
.title-text-style {
  padding-bottom: 0px;
}
.key_style {
  font-size: 13px;
  font-weight: bold;
}

.button-group {
  justify-content: flex-end;
  display: flex;
  gap: 15px;
}

.load-more-btn {
  text-transform: none;
  border: none;
}

.chat-button {
  border: 1px solid #37474f !important;
}
::v-deep(.chat-button .v-icon) {
  color: #fff !important;
}
.v-expansion-panels {
  z-index: 0 !important;
}

.v-expansion-panel >>> .v-expansion-panel-content__wrap {
  padding: 1px 16px 0px !important;
  margin-top: -20px;
  margin-bottom: 20px;
}
.selected-day-card {
  background-color: black !important;
  color: white !important;
  border: 1px solid black;
  cursor: pointer;
}

.default-day-card {
  background-color: transparent;
  color: black;
  border: 1px solid black;
  cursor: pointer;
}
.status-select {
  min-width: auto !important;
  max-width: 140px;
  padding: 0 !important;
}

.status-select .v-input__control,
.status-select .v-input__slot,
.status-select input {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
}
/* .status-select .v-input__append-inner {
  opacity: 1 !important;
}

.theme--dark.v-list {
  background-color: white !important;
}

.theme--dark >>> .v-list-item {
  color: #37474f00 !important;
} */

.status-activator {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

/* chip size */
.status-activator .v-chip {
  height: 28px;
  font-size: 12px;
  line-height: 18px;
}

.status-activator .status-chevron {
  font-size: 25px !important;
  color: #e6e6e6; /* adjust as needed */
  opacity: 1;
}

/* compact menu items */
::v-deep(.status-menu .v-list-item) {
  min-height: 28px !important;
  padding: 4px 8px !important;
}
</style>
